import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class LocaleService {

  // Get locale
  public getLocale(language: string): string {
    const locale = language;

    // This is not needed, because the user is authenticated and has a profile language
    // If language is English and localization is not US, use GB
    // if (language === 'en' && navigator.language.toLowerCase() !== 'en-us') {
    //   locale = 'en-gb';
    // }

    return locale;
  }

  // Get language
  public getLanguage(language: string): string {
      return language?.substring(0, 2);
  }

  public ConvertHourFormat(value: string): string {
    if (value) {
      return moment(value, 'HH:mm').format('LT');
    }
  }

  public ConvertTo24HourFormat(value: string): string {
    if (value) {
      return moment(value, ['h:mm A']).format('HH:mm');
    }
  }

  public ConvertTo12HourFormat(value: string): string {
    if (value) {
      return moment(value, ['HH:mm']).format('h:mm A');
    }
  }

  public ConvertDateString(value: string): string {
    let result = '';

    if (value) {
        result = moment.utc(value).local().format('L LT');
    }

    return result;
}
}
